import styled from 'styled-components';

export const CxSolutionPartnersStyles = styled.div`
  padding: 50px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;

  h1 {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: 700;
    line-height: 115%;
    max-width: 1170px;

    @media (max-width: 768px) {
      font-size: 28px;
    }
  }

  h2 {
    color: #fff;
    text-align: center;
    font-size: 40px;
    font-weight: 500;
    line-height: 115%;
    max-width: 1170px;

    @media (max-width: 768px) {
      font-size: 28px;
    }
  }

  .partner-quee {
    width: 100%;

    div {
      &::before {
        display: none;
      }
      &::after {
        display: none;
      }
    }
  }

  .logoWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;

    border: 2px solid #02ba95;
    width: 370px;
    height: 370px;
    border-radius: 100%;
    font-weight: 700;
    font-size: 40px;
    line-height: 120%;

    color: #000000;

    margin-left: -50px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      max-width: 60%;
    }

    img:nth-child(2) {
      display: none;
    }

    &:hover {
      img:nth-child(1) {
        display: none;
      }

      img:nth-child(2) {
        display: block;
      }
    }

    @media (max-width: 1000px) {
      height: 197px;
      width: 197px;

      margin-left: -30px;
      font-size: 21px;
    }

    @media (max-width: 600px) {
      height: 200px;
      width: 200px;

      margin-left: -30px;
      font-size: 21px;
    }
  }
`;
